// app/javascript/controllers/sub_category_controller.js
import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["categorySelect", "subCategorySelect"]

  connect() {
    // console.log("SubCategory controller connected")
  }

  loadSubCategories() {
    const categoryId = this.categorySelectTarget.value

    if (!categoryId) {
      this.clearSubCategories()
      return
    }

    const url = `/categories/${categoryId}/sub_categories`

    fetch(url, {
      headers: {
        'Accept': 'application/json'
      }
    })
      .then(res => res.json())
      .then(data => {
        this.populateSubCategories(data.sub_categories)
      })
      .catch(err => {
        console.error("Failed to load models", err)
        this.clearSubCategories()
      })
  }

  populateSubCategories(subCategories) {
    this.subCategorySelectTarget.innerHTML = ""

    const defaultOption = document.createElement("option")
    defaultOption.value = ""
    defaultOption.textContent = "-- Select Model --"
    this.subCategorySelectTarget.appendChild(defaultOption)

    subCategories.forEach(([id, name]) => {
      const option = document.createElement("option")
      option.value = id
      option.textContent = name
      this.subCategorySelectTarget.appendChild(option)
    })
  }

  clearSubCategories() {
    this.subCategorySelectTarget.innerHTML = ""
    const option = document.createElement("option")
    option.value = ""
    option.textContent = "-- Select Model --"
    this.subCategorySelectTarget.appendChild(option)
  }
}